
import React from 'react';
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Auth from "./layout/firebase/auth";
import "./index.scss";
import Loader from './layout/layoutcomponent/loaders';
import { GoogleOAuthProvider } from "@react-oauth/google"
import { Routingdata } from './common/routingdata';
// import { ProtectedRoutes } from './common/utilities/protectedRoute';
// import { isAuthorizedRoute } from './common/utilities/authorizedRoute';
import { PermissionProvider, routePermission } from './common/utilities/authContext';
import { Provider, useSelector } from 'react-redux';
import store, { RootState } from './common/store/store';
import TestLoader from './layout/layoutcomponent/testloader';



const App = React.lazy(() => import("./layout/App"));
const Custompages = React.lazy(() => import("./layout/custompages"));

//pages
const SignUp = React.lazy(() =>
  import("./components/pages/authentication/signup/signup")
);

const SignIn = React.lazy(() =>
  import("./components/pages/authentication/signin/signin")
);
const ForgotPassword = React.lazy(() =>
  import("./components/pages/authentication/forgotpassword/forgotpassword")
);

const ResetPassword = React.lazy(() =>
  import("./components/pages/authentication/resetpassword/resetpassword")
);

const VerifyEmail = React.lazy(() =>
  import("./components/pages/authentication/verifyemail/verifyemail")
)

const PrivacyPolicy = React.lazy(() =>
  import("./components/pages/authentication/privacypolicy/privacypolicy")
)
const TermsConditions = React.lazy(() =>
  import("./components/pages/authentication/termsconditions/termsconditions")
)

const RefundDisputePolicy = React.lazy(() =>
  import("./components/pages/authentication/refunddisputepolicy/refunddisputepolicy")
)


// const Dashboard = React.lazy(() =>
//   import("./components/pages/authentication//dashboard/demoDashboard")
// )

// const ClubProfile = React.lazy(() =>
//   import("./components/pages/authentication/clubprofile/clubprofile")
// )



//Form
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const Main = () => {
  const { loading } = routePermission();
  const { isLoggedIn } = useSelector((state: RootState) => state.auth)

  if (isLoggedIn && loading) {
    return <TestLoader />
  }





  return (
    <React.Fragment>
      <BrowserRouter>
        <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
          <React.Suspense fallback={<Loader />}>
            <Routes>
              <Route path={`${import.meta.env.BASE_URL}`} element={<Auth />}>
                <Route index element={<SignIn />} />
              </Route>
              {/* <Route path={`${import.meta.env.BASE_URL}`} element={<ProtectedRoutes><App /></ProtectedRoutes>} >
                {Routingdata.map((idx, index) => (
                  <Route path={idx.path} element={isAuthorizedRoute(allowedRoutes, idx.path) ? (
                    <ProtectedRoutes>{idx.element}</ProtectedRoutes>
                  ) : (
                    <Navigate to="/" replace />
                  )} key={index} />
                ))}
              </Route> */}
              <Route path={`${import.meta.env.BASE_URL}`} element={<App />}>
                {Routingdata.map((idx, index) => (
                  <Route path={idx.path} element={idx.element} key={index} />
                ))}
              </Route>
              <Route path={`${import.meta.env.BASE_URL}`} element={<Custompages />}>
                <Route path={`${import.meta.env.BASE_URL}signin`} element={<SignIn />} />
                <Route path={`${import.meta.env.BASE_URL}signup`} element={<SignUp />} />
                <Route path={`${import.meta.env.BASE_URL}pages/authentication/forgotpassword`} element={<ForgotPassword />} />
                <Route path={`${import.meta.env.BASE_URL}/resetpassword`} element={<ResetPassword />} />
                <Route path={`${import.meta.env.BASE_URL}verifyemail`} element={<VerifyEmail />} />
                  <Route path={`${import.meta.env.BASE_URL}privacypolicy`} element={<PrivacyPolicy />} />
                  <Route path={`${import.meta.env.BASE_URL}termsconditions`} element={<TermsConditions />} />
                  <Route path={`${import.meta.env.BASE_URL}refunddisputepolicy`} element={<RefundDisputePolicy />} />
                {/* <Route path={`${import.meta.env.BASE_URL}dashboard`} element={<Dashboard />} />
                <Route path={`${import.meta.env.BASE_URL}clubprofile`} element={<ClubProfile />} /> */}
              </Route>
              <Route></Route>
            </Routes>
          </React.Suspense>
        </GoogleOAuthProvider>
      </BrowserRouter>
    </React.Fragment>
  );
}

root.render(
  <Provider store={store}>
    <PermissionProvider>
      <Main />
    </PermissionProvider>
  </Provider>
);

